webpackJsonp([239286642868403],{

/***/ 1808:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/news/automotive-the-digital-battleground/"},"frontmatter":{"title":"Automotive & The Digital Battleground","templateKey":"news","thumb":{"responsive":{"childImageSharp":{"original":{"src":"/static/1160x450-automotive-article-header-image-v1-725821caabf0948b48d479ccdec70d64.jpg"}}},"original":"/img/1160x450-automotive-article-header-image-v1.jpg"},"category":"Insight"}}}]}},"pathContext":{"tag":"AUTOMOTIVE"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-automotive-85c888ce94b88ff87297.js